import React, { useEffect } from 'react';
import { BonusSection } from './components/BonusSection';
import { ClosingArgument } from './components/ClosingArgument';
import { EverythingIncluded } from './components/EverythingIncluded';
import { VisualSection } from './components/VisualSection';
import { FAQ } from './components/FAQ';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { Guarantee } from './components/Guarantee';
import { Hero } from './components/Hero';
import { PainPoints } from './components/PainPoints';
import { PricingSection } from './components/PricingSection';
import { PurchaseNotification } from './components/PurchaseNotification';
import { ProductGallery } from './components/ProductGallery';
import { SolutionReveal } from './components/SolutionReveal';
import { TestimonialsStrip } from './components/TestimonialsStrip';
import { VolumesSection } from './components/VolumesSection';
import { META_PIXEL_ID } from './utils/tracking';
type MetaPixel = ((...args: unknown[]) => void) & {
  callMethod?: (...args: unknown[]) => void;
  queue?: unknown[][];
  push?: (...args: unknown[]) => void;
  loaded?: boolean;
  version?: string;
};
declare global {
  interface Window {
    fbq?: MetaPixel;
    _fbq?: MetaPixel;
  }
}
interface AppProps {
  showTestimonials?: boolean;
  showPurchaseNotifications?: boolean;
}
export function App({
  showTestimonials = true,
  showPurchaseNotifications = true
}: AppProps) {
  useEffect(() => {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;
    try {
      if (!window.fbq) {
        const pixel: MetaPixel = (...args: unknown[]) => {
          if (pixel.callMethod) pixel.callMethod(...args);else pixel.queue?.push(args);
        };
        pixel.queue = [];
        pixel.loaded = true;
        pixel.version = '2.0';
        pixel.push = (...args: unknown[]) => pixel(...args);
        window.fbq = pixel;
        window._fbq = pixel;
        const script = document.createElement('script');
        script.async = true;
        script.src = 'https://connect.facebook.net/en_US/fbevents.js';
        (document.head || document.body || document.documentElement).appendChild(script);
        window.fbq('init', META_PIXEL_ID);
      }
      window.fbq('track', 'PageView');
    } catch (error) {
      console.warn('Meta Pixel initialization failed:', error);
    }
  }, []);
  return <div className="min-h-screen w-full bg-stone-50 text-slate-800" data-id="element-0" data-mp="3gl4pnbwh7qhe">
      <main data-id="element-1" data-mp="3gja2rs1n9oao">
        <Hero data-id="element-2" data-mp="3bmbf9schkflg" />
        {showTestimonials && <TestimonialsStrip data-id="element-3" data-mp="3bncqbwti5236" />}
        <ProductGallery data-id="element-4" data-mp="3bo4mp9uxb3ui" />
        <PainPoints data-id="element-5" data-mp="3qb7j1d7if6g9" />
        <SolutionReveal data-id="element-6" data-mp="3qbpon0g2ax0u" />
        <VisualSection data-id="element-7" data-mp="3qbzfsrcufa84" />
        <VolumesSection data-id="element-8" data-mp="3qcin7e4vag7w" />
        <BonusSection data-id="element-9" data-mp="3lkhe212zx5m3" />
        <PricingSection data-id="element-10" data-mp="3ljxygr0titb8" />
        <ClosingArgument data-id="element-11" data-mp="3ljpiurdb99wc" />
        <Guarantee data-id="element-12" data-mp="3liedwo84pw3n" />
        <FAQ data-id="element-13" data-mp="2xuwsdafgju94" />
        <FinalCTA data-id="element-14" data-mp="2xudatutpz7vm" />
        <EverythingIncluded data-id="element-15" data-mp="2xtv6sc0tfpd5" />
      </main>
      <Footer data-id="element-16" data-mp="2xssebznuhev4" />
      {showPurchaseNotifications && <PurchaseNotification data-id="element-17" data-mp="2swll97gjrxul" />}
      <noscript data-id="element-18" data-mp="2svafj23jkg0u">
        <img height="1" width="1" style={{
        display: 'none'
      }} alt="" src={`https://www.facebook.com/tr?id=${META_PIXEL_ID}&ev=PageView&noscript=1`} data-id="element-19" data-mp="2stpnbj4p9965" />
      </noscript>
    </div>;
}